// Use Dawn's existing slider for arrows and native touch scrolling.
customElements.whenDefined('slider-component').then(() => {
  if (customElements.get('oe-benefits-slider')) return;

  customElements.define('oe-benefits-slider', class extends customElements.get('slider-component') {
    connectedCallback() {
      if (!this.slider || this.sliderItems.length < 2) return;
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.mobile = window.matchMedia('(max-width: 767px)');
      this.dots = Array.from(this.querySelectorAll('[data-benefit-dot]'));
      this.status = this.querySelector('[data-benefit-status]');
      this.dataset.carouselReady = '';

      this.addEventListener('slideChanged', () => this.updateDots(), options);
      this.addEventListener('click', (event) => {
        const dot = event.target.closest('[data-benefit-dot]');
        if (dot && this.mobile.matches) this.goTo(Number(dot.dataset.benefitDot));
      }, options);
      this.addEventListener('keydown', (event) => {
        if (!this.mobile.matches) return;
        const index = (this.currentPage || 1) - 1;
        const target = { ArrowLeft: index - 1, ArrowRight: index + 1, Home: 0, End: this.sliderItems.length - 1 }[event.key];
        if (target === undefined) return;
        event.preventDefault();
        this.goTo(target);
      }, options);
      this.mobile.addEventListener('change', () => this.updateLayout(), options);
      this.addEventListener('shopify:block:select', (event) => {
        if (!this.mobile.matches) return;
        const index = Array.from(this.sliderItems).findIndex(item => item.contains(event.target));
        if (index >= 0) this.goTo(index);
      }, options);
      this.updateLayout();
    }

    disconnectedCallback() {
      this.controller?.abort();
    }

    updateLayout() {
      if (this.mobile.matches) {
        this.setAttribute('role', 'region');
        this.setAttribute('aria-roledescription', 'Karussell');
        this.setAttribute('aria-label', 'Ihre Vorteile bei Ofenerlebnis');
      } else {
        this.removeAttribute('role');
        this.removeAttribute('aria-roledescription');
        this.removeAttribute('aria-label');
        this.slider.scrollTo({ left: 0, behavior: 'instant' });
      }
      this.initPages();
      this.updateDots();
    }

    goTo(index) {
      const target = Math.max(0, Math.min(this.sliderItems.length - 1, index));
      this.setSlidePosition(target * this.sliderItemOffset);
    }

    updateDots() {
      const index = Math.max(0, Math.min(this.sliderItems.length - 1, (this.currentPage || 1) - 1));
      // Same moving window as oe-collection-product-card.js: at most three dots.
      const start = Math.max(0, Math.min(index - 1, this.dots.length - 3));
      const focusedDot = this.dots.find(dot => dot === document.activeElement);
      this.dots.forEach((dot, i) => {
        dot.hidden = i < start || i >= start + 3;
        if (i === index) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
      if (this.mobile.matches && focusedDot?.hidden) {
        this.dots[index].focus({ preventScroll: true });
      }
      this.sliderItems.forEach((item, i) => {
        if (this.mobile.matches) item.setAttribute('aria-hidden', String(i !== index));
        else item.removeAttribute('aria-hidden');
      });
      this.status.textContent = this.mobile.matches ? `Vorteil ${index + 1} von ${this.sliderItems.length}` : '';
    }
  });
});
